import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_LICENSE: createAsyncMutation('GET_LICENSE'),
    GET_LICENSES_CUSTOMER: createAsyncMutation('GET_LICENSES_CUSTOMER'),
    GET_ALL_LICENSES_FOR_CUSTOMER: createAsyncMutation('GET_ALL_LICENSES_FOR_CUSTOMER'),
    GET_CODE_TYPE: createAsyncMutation('GET_CODE_TYPE'),
}

const license = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getLicensesCustomer(store, customerId) {
            let url = api.license + 'Customer/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSES_CUSTOMER })
        },
        getAllLicensesForCustomer(store, customerId) {
            let url = api.license + 'GetAllLicensesForCustomer/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_ALL_LICENSES_FOR_CUSTOMER })
        },
        getLicense(store, id) {
            let url = api.license + id
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSE })
        },
        getCodeType(store, code) {
            let url = api.licenseKey + 'GetCodeType/' + code
            return doAsyncGet(store, { url, mutationTypes: types.GET_CODE_TYPE })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default license
